
/**
 * генерируем гуид
 * @returns {string}
 */
const generateGuid = function () {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = Math.random() * 16 | 0; const v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
};

const state = {
  login: '',
  loggedIn: false,
  accessToken: localStorage.getItem('accessToken') !== null ? localStorage.getItem('accessToken') : '',
  refreshToken: localStorage.getItem('refreshToken') !== null ? localStorage.getItem('refreshToken') : '',
  xSession: localStorage.getItem('xSession') !== null ? localStorage.getItem('xSession') : generateGuid()
};

const getters = {
  isAuthenticated: state => {
    return state.accessToken.length > 0 && state.refreshToken.length > 0
  }
};

const actions = {
  clearLocalStorageAuth: ({ commit }) => {
    commit('setAuthData', {
      accessToken: '',
      refreshToken: '',
      xSession: ''
    });
  }
};

const mutations = {
  /**
   * Запихиваем в state и localStorage данные авторизации пользователя
   * @param state
   * @param values {accessToken: string, accessToken: string}
   */
  setAuthData: (state, values) => {
    state.accessToken = values.accessToken;
    state.refreshToken = values.refreshToken;
    localStorage.setItem('accessToken', values.accessToken);
    localStorage.setItem('refreshToken', values.refreshToken);
  },
  setLogin: (state, value) => {
    state.login = value;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
